import { Button, Drawer, Form, Input, Modal, Select, Space, InputRef, Table} from "antd";
import { connect } from "react-redux";
import { AppState } from "src/store";
import style from './Tables.module.scss'
import { getAllCategoryTable, getCategoryById, postResgisterCategory, putResgisterCategory } from "src/store/category/thunks";
import { SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined } from '@ant-design/icons';
import { SizeType } from "antd/es/config-provider/SizeContext";
import validateMessages from "src/globals/Inputs/validateMessages";
import TextArea from "antd/es/input/TextArea";
import form from "antd/es/form";
import { NamePath } from "antd/es/form/interface";
import { Category } from "src/store/category/type";
import { validate1, validate150 } from "src/globals/Inputs/validateInput";
import type { FilterConfirmProps } from 'antd/es/table/interface';
import type { ColumnsType, ColumnType } from 'antd/es/table';
import React, { useRef, useState, useEffect } from 'react';
import { TRUE } from "sass";


interface TableProps {
    getAllCategoryTable?: any;
    putResgisterCategory?: any;
    postResgisterCategory?: any;
    getCategoryById?: any;
}

/*id:string
    name:string,
    type:string,    
    description:string,
    created_at:string*/

interface DataType {
    key: string;
    id: string;
    type: string;
    name: string;
    description: string;
    createdAt: string;
}

type DataIndex = keyof DataType;
type RequiredMark = boolean | 'optional';
const TCategory: React.FC<TableProps> = (props: TableProps) => {
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<InputRef>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFormValidate, setIsFormValidate] = useState(true);
    const [typeModal, setTypeModal] = useState(true);
    const [idCategory, setIdCategory] = useState('');
    const [formValidate] = Form.useForm();
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const { Option } = Select;
    //LLamar al EndPoint tanto en el Iterface como en el Map, 
    const init = async () => {
        const responseDataCategory = await props.getAllCategoryTable();
        setDataTable(responseDataCategory);
    }

    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex: DataIndex, title: string): ColumnType<DataType> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Buscar ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reiniciar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },

    });

    useEffect(() => {
        init();
    }, []);

    //Crear una tabla.
    const [dataTable, setDataTable] = useState([]);

    const columns: ColumnsType<DataType> = [
        {
            title: 'Nombre',
            width: 25,
            dataIndex: 'name',
            key: 'name',
            ...getColumnSearchProps('name', 'name'),
            sorter: (a, b) => {
                const dateA = new Date(a.name);
                const dateB = new Date(b.name);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'Número',
            width: 5,
            dataIndex: 'type',
            key: 'type',
            filters: [
                {
                    text: '1',
                    value: '1',
                },
                {
                    text: '2',
                    value: '2',
                },
                {
                    text: '3',
                    value: '3',
                },
                {
                    text: '4',
                    value: '4',
                },
                {
                    text: '5',
                    value: '5',
                },
                {
                    text: '6',
                    value: '6',
                },
            ],
            onFilter: (value: string | number | boolean, record) => {
                if (typeof value === 'string') {
                    return record.type.indexOf(value) === 0;
                }
                return false;
            },
            
        },
        {
            title: 'Descripción',
            dataIndex: 'description',
            key: 'description',
            width: 40,
        },
        {
            title: 'Creado',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 8,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
            ...getColumnSearchProps('createdAt', 'createdAt'),

        },
        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 3,

            render: (record: DataType) =>
                <Space size="middle">
                    <Button
                        type="text"
                        className={style["update-button"]}
                        onClick={() => handleTypeOpenModelUpdate(record.id)}
                        icon={<EditOutlined />}
                    />
                </Space>,
        },

    ];
    const handleCancel = () => {
        formValidate.resetFields();
        setIsModalOpen(false)
    };
    const handleTypeOpenModel = () => {
        setIsModalOpen(true)
        setTypeModal(true)
    };
    const handleTypeOpenModelUpdate = async (value: String) => {
        setIsModalOpen(true)
        setTypeModal(false)
        const responseData: Category = await props.getCategoryById(value);
        setIdCategory(responseData.id)
        formValidate.setFieldsValue({
            name: responseData.name, type: responseData.type, description: responseData.description
        });
    };
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };

    const onFinish = async (values: any) => {
        
        if (!typeModal) {
            const Category = {
                id: idCategory,
                name: values.name,
                type: values.type,
                description: values.description == undefined ? ' ' : values.description,
            };
            await props.putResgisterCategory(Category);
        } else {
            const Category = {
                name: values.name,
                type: values.type,
                description: values.description == undefined ? ' ' : values.description,
            };
            await props.postResgisterCategory(Category);
        }
        //handleCancel();
        const responseData = await props.getAllCategoryTable();
        setDataTable(responseData);
        formValidate.resetFields();
    };

    return (
        <>
            <Button
                type="primary"
                icon={<PlusCircleOutlined />}
                className={style["create-button-user"]}
                onClick={handleTypeOpenModel}
                hidden = {true}
            >
                Crear categoría
            </Button>
            <Table size="small" columns={columns} dataSource={dataTable} scroll={{ x: 1500 }} />
            <Drawer title={typeModal ? "Crear categoría" : "Actualizar categoría"} open={isModalOpen} onClose={handleCancel} width={350} footer={null}>
                <Form
                    form={formValidate}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinish}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item label="Nombre" name="name" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) },
                    ]}>
                        <Input placeholder="Ingresar nombre" />
                    </Form.Item>
                    <Form.Item
                        label="Número"
                        name="type"
                        rules={[
                            { required: true, message: validateMessages.emptyField },
                            { validator: (_, value) => validate1(value) },
                        ]}
                    >
                        <Select placeholder="Seleccionar número" disabled={!typeModal}>
                            <Option value="1">Tipo 1</Option>
                            <Option value="2">Tipo 2</Option>
                            <Option value="3">Tipo 3</Option>
                            <Option value="4">Tipo 4</Option>
                            <Option value="5">Tipo 5</Option>
                            <Option value="6">Tipo 6</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="Descripción" name="description">
                        <TextArea placeholder="Ingresar descripción / Alcance" rows={4} />
                    </Form.Item>
                    <Form.Item>
                        <Button className={style["user-button"]} type="primary" htmlType="submit">
                            {typeModal ? "Ingresar" : "Actualizar"}
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
        </>


    );


};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getAllCategoryTable, postResgisterCategory, putResgisterCategory, getCategoryById
})(TCategory);